import styled from "@emotion/styled"
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material"
import { ArrowDown, CheckboxIcon, CheckedCheckboxIcon } from "ui"
import { extractProperty } from "utils"
import SectionTitles from "./SectionTitles"

type Props = {
  title: string
  subtitle: string
  filteredFiles: any

  selectedCategories: any
  handleCategoriesChange: any
}

const StyleDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  .MuiFormControl-root {
    width: 100%;
    ${(props) => props.theme.breakpoints.up("md")} {
      width: 328px;
    }
  }
  .MuiSelect-icon {
    top: calc(50% - 12px);
    right: 8px;
  }
  span {
    font-size: 18px;
  }
`

const Category = ({
  title,
  subtitle,
  filteredFiles,

  selectedCategories,
  handleCategoriesChange,
}: Props) => {
  const allCategories = filteredFiles.map((file: any) => {
    const category = extractProperty(file, "selectCategory")?.[0]

    return extractProperty(category, "selectCategory")
  })

  // Flatten the nested arrays and get unique values
  const uniqueCategories = [...new Set(allCategories.flat().filter(Boolean))] as string[]

  return (
    <StyleDiv>
      <SectionTitles title={title} subtitle={subtitle} />
      <FormControl>
        <InputLabel id="demo-multiple-checkbox-label">{title}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selectedCategories}
          onChange={handleCategoriesChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => selected.join(", ")}
          IconComponent={ArrowDown}
          MenuProps={{
            PaperProps: {
              sx: {
                paddingBottom: "16px",
                borderBottomRightRadius: "8px",
                borderBottomLeftRadius: "8px",
                height: "195px",
                "& .MuiMenuItem-root": {
                  padding: 2,
                  fontSize: "18px",
                  borderBottom: "1px solid #6F6F6F",
                },
                "& .MuiTypography-root": {
                  fontSize: "18px",
                },
                // Scrollbar styling
                "&::-webkit-scrollbar": {
                  width: "5px",
                },
                "&::-webkit-scrollbar-button": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#2768A3",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  },
                },
              },
            },
          }}
        >
          {uniqueCategories.map((category: string) => (
            <MenuItem key={category} value={category}>
              <Checkbox
                checked={selectedCategories.includes(category)}
                icon={<CheckboxIcon />}
                checkedIcon={<CheckedCheckboxIcon color="#2768A3" />}
              />
              <ListItemText primary={category} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </StyleDiv>
  )
}
export default Category
